export class OneSignalConstants {
	public static readonly PUBLICKEY = '4745b982-3db6-4a75-9e00-993e2b1c853c'
	public static readonly APPID = '4745b982-3db6-4a75-9e00-993e2b1c853c'
};